import i18n from "@/i18n";
import { pickAdminFormPaths } from "../admin-form-editor-i18n-paths";
import type { FormEditorEntity } from "../form-editor-entity.types";

/**
 * Returns a trimmed section label for the form builder, or the localized default when the value
 * is missing or whitespace-only.
 */
export function resolveBuilderSectionLabel(
	raw: string | undefined,
	formEditorEntity: FormEditorEntity,
): string {
	const fallbackKey =
		pickAdminFormPaths(formEditorEntity).formEditor.defaults.newSectionLabel;
	if (typeof raw !== "string") {
		return String(i18n.t(fallbackKey as never));
	}
	const trimmed = raw.trim();
	if (trimmed.length > 0) return trimmed;
	return String(i18n.t(fallbackKey as never));
}
